import {
  GET_CATEGORY_LIST_REQUEST,
  GET_CATEGORY_LIST_RESPONSE,
  GET_CATEGORY_LIST_FOR_SUB_CATEGORY_REQUEST,
  GET_CATEGORY_LIST_FOR_SUB_CATEGORY_RESPONSE,
  GET_CATEGORY_LIST_FOR_PRODUCT_CATEGORY_REQUEST,
  GET_CATEGORY_LIST_FOR_PRODUCT_CATEGORY_RESPONSE,
  GET_CHILD_CATEGORY_LIST_REQUEST,
  GET_CHILD_CATEGORY_LIST_RESPONSE,
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_RESPONSE,
  UPDATE_CATEGORY_BY_CATEGORY_ID_REQUEST,
  UPDATE_CATEGORY_BY_CATEGORY_ID_RESPONSE,
  DELETE_CATEGORY_BY_CATEGORY_ID_REQUEST,
  DELETE_CATEGORY_BY_CATEGORY_ID_RESPONSE,
  UPDATE_CATEGORY_STATUS_BY_CATEGORY_ID_REQUEST,
  UPDATE_CATEGORY_STATUS_BY_CATEGORY_ID_RESPONSE,
} from "./actionTypes";

export const getCategoryListRequest = () => {
  return {
    type: GET_CATEGORY_LIST_REQUEST,
  };
};

export const getCategoryListResponse = (apiResponse) => {
  return {
    type: GET_CATEGORY_LIST_RESPONSE,
    payload: { apiResponse },
  };
};

export const getCategoryListForSubCategoryRequest = () => {
  return {
    type: GET_CATEGORY_LIST_FOR_SUB_CATEGORY_REQUEST,
  };
};

export const getCategoryListForSubCategoryResponse = (apiResponse) => {
  return {
    type: GET_CATEGORY_LIST_FOR_SUB_CATEGORY_RESPONSE,
    payload: { apiResponse },
  };
};

export const getCategoryListForProductCategoryRequest = () => {
  return {
    type: GET_CATEGORY_LIST_FOR_PRODUCT_CATEGORY_REQUEST,
  };
};

export const getCategoryListForProductCategoryResponse = (apiResponse) => {
  return {
    type: GET_CATEGORY_LIST_FOR_PRODUCT_CATEGORY_RESPONSE,
    payload: { apiResponse },
  };
};

export const getChildCategoryListRequest = () => {
  return {
    type: GET_CHILD_CATEGORY_LIST_REQUEST,
  };
};

export const getChildCategoryListResponse = (apiResponse) => {
  return {
    type: GET_CHILD_CATEGORY_LIST_RESPONSE,
    payload: { apiResponse },
  };
};

export const addCategoryRequest = (data) => {
  return {
    type: ADD_CATEGORY_REQUEST,
    payload: { data },
  };
};

export const addCategoryResponse = (apiResponse) => {
  return {
    type: ADD_CATEGORY_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateCategoryByCategoryIdRequest = (categoryId, data) => {
  return {
    type: UPDATE_CATEGORY_BY_CATEGORY_ID_REQUEST,
    payload: { categoryId, data },
  };
};

export const updateCategoryByCategoryIdResponse = (apiResponse) => {
  return {
    type: UPDATE_CATEGORY_BY_CATEGORY_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateCategoryStatusByCategoryIdRequest = (categoryId, status) => {
  return {
    type: UPDATE_CATEGORY_STATUS_BY_CATEGORY_ID_REQUEST,
    payload: { categoryId, status },
  };
};

export const updateCategoryStatusByCategoryIdResponse = (apiResponse) => {
  return {
    type: UPDATE_CATEGORY_STATUS_BY_CATEGORY_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const deleteCategoryByCategoryIdRequest = (categoryId) => {
  return {
    type: DELETE_CATEGORY_BY_CATEGORY_ID_REQUEST,
    payload: { categoryId },
  };
};

export const deleteCategoryByCategoryIdResponse = (apiResponse) => {
  return {
    type: DELETE_CATEGORY_BY_CATEGORY_ID_RESPONSE,
    payload: { apiResponse },
  };
};
